<template>
  <common-page-layout>   
    <span slot="fixedtopbuttons">
      <large-button @click="$router.push('home')">
        Home
      </large-button>
    </span>
    <div v-if="help" v-html="help.htmlcontent"></div>
  </common-page-layout>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
      ...mapActions(["getHelpPage"])
  },
  mounted() {
    this.getHelpPage('termsconditions').then((content)=>{          
          this.help = content          
    })
  },
  data: function() {
    return {          
        help:null
    };
  }
};

</script>



// WEBPACK FOOTER //
// src/components/TANDCS.vue